module.exports = __webpack_public_path__ + "static/map-7bb624ff825781feb96c2894a188c34c.jpg";